module.exports = __webpack_public_path__ + "static/media/canal.83167b0b.png";